import { SubmissionGroupEntityInterface } from '@types';

export const getSubmissionGroupName = (
  submissionGroups: SubmissionGroupEntityInterface[],
  groupId: string
): string => {
  return submissionGroups.find(({ id }) => id === groupId)?.name;
};
